import Image from 'next/legacy/image';
import Link from 'next/link';
import React from 'react';

interface CategoryTileProps {
  title: string;
  href: string;
  src?: string;
}

const CategoryTile: React.FC<CategoryTileProps> = ({ title, href, src }) => {
  return (
    <Link href={href}>
      <div
        className={
          'border-grey-50 text-text-light-bg-primary flex min-h-48 max-w-md cursor-pointer flex-col gap-2 rounded-2xl border shadow-sm lg:hover:shadow-lg'
        }
      >
        <div className={'relative h-36 w-full'}>
          <Image
            src={src || '/images/petsdeli-logo.svg'}
            className="rounded-t-xl"
            data-test="blog-image"
            layout={'fill'}
            objectFit={'cover'}
          />
        </div>
        <div className={'border-grey-50 flex max-w-md flex-col rounded-2xl'}>
          <p className={'text-center font-black'}>{title}</p>
        </div>
      </div>
    </Link>
  );
};

export default CategoryTile;
